'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const CashFlowChart = dynamic(() => import('./charts/CashFlowChart'), { ssr: false });
const SpendingPieChart = dynamic(() => import('./charts/SpendingPieChart'), { ssr: false });

export default function DashboardCharts() {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-3 2xl:grid-cols-3 gap-6">
      <div className="xl:col-span-2 bg-card border border-border rounded-xl p-5">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-base font-600 text-foreground">Cash Flow Trend</h3>
            <p className="text-xs text-muted-foreground mt-0.5">Income vs Expenses — last 12 weeks</p>
          </div>
          <div className="flex items-center gap-3 text-xs">
            <span className="flex items-center gap-1.5"><span className="w-3 h-1.5 rounded-full bg-success inline-block" />Income</span>
            <span className="flex items-center gap-1.5"><span className="w-3 h-1.5 rounded-full bg-danger inline-block" />Expenses</span>
          </div>
        </div>
        <CashFlowChart />
      </div>
      <div className="bg-card border border-border rounded-xl p-5">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-base font-600 text-foreground">Spending Breakdown</h3>
            <p className="text-xs text-muted-foreground mt-0.5">This month by category</p>
          </div>
        </div>
        <SpendingPieChart />
      </div>
    </div>
  );
}